export const PREFIX = 'aaf_';

// Focusable class names.
export const FOCUSABLE = `${PREFIX}focusable`;
export const FOCUSABLE_ROUNDED = `${PREFIX}focusable-rounded`;

// Alert class names.
export const ALERT = `${PREFIX}alert`;
export const ALERT_FULL = `${PREFIX}alert-full`;
export const ALERT_BODY = `${PREFIX}alert-body`;
export const ALERT_BUTTON = `${PREFIX}alert-button`;
export const ALERT_BUTTON_CLOSE = `${ALERT_BUTTON}-close`;
export const ALERT_DEFAULT = `${PREFIX}alert-default`;
export const ALERT_INFO = `${PREFIX}alert-info`;
export const ALERT_FOCUSABLE = `${PREFIX}alert-focusable`;

// Tooltiop.
export const TOOLTIP = `${PREFIX}tooltip`;
export const TOOLTIP_CONTENT = `${PREFIX}tooltip-content`;
export const TOOLTIP_TITLE = `${PREFIX}tooltip-title`;

// List
export const LIST = `${PREFIX}list`;
export const LIST_ITEM = `${PREFIX}list-item`;

// input
export const INPUT = `${PREFIX}input`;

// Button.
// Button class names.
export const BUTTON = `${PREFIX}button`;
export const BUTTON_BLOCK = `${PREFIX}button-block`;

// Checkbox
export const GROUP = `${PREFIX}form-group`;
export const GROUP_TEXT_DEFAULT = `${GROUP}-text`;
export const GROUP_PLACEHOLDER = `${GROUP}-placeholder`;
// `new-form-group-placeholder`

// Group input
export const GROUP_BLINK = `${GROUP}-cursor to-blink`;
export const GROUP_FOCUS = `${GROUP}-focus`;
export const GROUP_ERROR = `${GROUP}-error`;
export const GROUP_FOCUSABLE = `focusable`;
export const FOCUSED = 'focused';
export const CONTROL_FOCUSED = `${PREFIX}form-control-focused`;
export const CONTROL_SELECTED = `${PREFIX}form-control-selected`;
export const GROUP_VALUE = `${GROUP}-value`;
export const GROUP_INPUT = `${GROUP}-input`;
export const GROUP_INPUT_ELEMENT = `${GROUP}-input-element`;
export const GROUP_LABEL = `${GROUP}-label`;
export const GROUP_CHECKBOX = `${GROUP}-checkbox`;
export const CONTROL_ONBLUR = `${INPUT}-onblur`;

// Avatar.
export const AVATAR = `${PREFIX}avatar`;
export const AVATAR_DEFAULT = `${PREFIX}avatar-default`;

// Image.
export const IMAGE = `${PREFIX}image`;
export const IMAGE_FIXED_WIDTH = `${PREFIX}image-fixed-width`;

// Grid.
export const GRID = `${PREFIX}grid`;
export const ROW = `${PREFIX}row`;
export const COLUMN = `${PREFIX}column`;

// Keyboard class names
export const KEYBOARD_PREFIX = `${PREFIX}keyboard`;

export const KEYBOARD = KEYBOARD_PREFIX;
export const KEYBOARD_KEYSET = `${KEYBOARD_PREFIX}-keyset`;
export const KEYBOARD_KEYSET_LINE = `${KEYBOARD_PREFIX}-keyset-line`;
export const KEYBOARD_KEYSET_LINE_CENTERED = `${KEYBOARD_PREFIX}-keyset-line-centered`;
export const KEYBOARD_KEYSET_LINE_CENTERED_LAST_ROW = `${KEYBOARD_PREFIX}-keyset-line-centered-last-row`;
export const KEYBOARD_KEYSET_LINE_CENTERED_LAST_ROW_SEARCH = `${KEYBOARD_PREFIX}-keyset-line-centered-last-row-search`;

export const KEYBOARD_HEADER = `${KEYBOARD_PREFIX}-header`;
export const KEYBOARD_BODY = `${KEYBOARD_PREFIX}-body`;
export const KEYBOARD_FOOTER = `${KEYBOARD_PREFIX}-footer`;
export const KEYBOARD_ROW = `${KEYBOARD_PREFIX}-row`;
export const KEYBOARD_CENTER = `${KEYBOARD_PREFIX}-center`;
export const KEYBOARD_DEFAULT = `${KEYBOARD_PREFIX}-default`;
export const KEYBOARD_TABS = `${KEYBOARD_PREFIX}-tabs`;
export const KEYBOARD_TAB = `${KEYBOARD_PREFIX}-tab`;
export const KEYBOARD_TAB_IMAGE = `${KEYBOARD_TAB}-image`;
export const KEYBOARD_TAB_CONTENT = `${KEYBOARD_TAB}-content`;
export const KEYBOARD_TAB_ACTIVE = `${KEYBOARD_TAB} active`;
export const KEYBOARD_TAB_TRANSPARENT = `${KEYBOARD_TAB}-transparent`;

export const KEYBOARD_KEY = `${KEYBOARD_PREFIX}-key`;
export const KEYBOARD_KEY_SHIFT_IMAGE = `${KEYBOARD_KEY}-shift-image`;
export const KEYBOARD_KEY_SPACE_IMAGE = `${KEYBOARD_KEY}-space-image`;
export const KEYBOARD_KEY_SPACE_IMAGE_SEARCH = `${KEYBOARD_KEY}-space-image-search`;
export const KEYBOARD_KEY_LETTER = `${KEYBOARD_PREFIX}-key-letter`;
export const KEYBOARD_KEY_IMAGE = `${KEYBOARD_PREFIX}-key-image`;
export const KEYBOARD_KEY_ICON = `${KEYBOARD_PREFIX}-key-icon`;
export const KEYBOARD_FOCUSABLE_KEY = `${KEYBOARD_PREFIX}-focusable-key`;
export const KEYBOARD_FOCUSABLE_KEY_LETTER = `${KEYBOARD_FOCUSABLE_KEY}-letter`;
export const KEYBOARD_FOCUSABLE_KEY_ICON = `${KEYBOARD_FOCUSABLE_KEY}-icon`;

export const KEYBOARD_KEYLINE = `${KEYBOARD_PREFIX}-keyline`;
export const KEYBOARD_KEYLINE_CENTERED = `${KEYBOARD_PREFIX}-keyline-centered`;

// Form.
export const FORM = `${PREFIX}form-component`;

// Font Awesome.
export const FONT_AWESOME_PREFIX = 'fa';
export const FONT_AWESOME = FONT_AWESOME_PREFIX;

// Colored buttons.
export const COLORED_BUTTON = `${PREFIX}colored-button`;
export const COLORED_BUTTON_PREFIX = COLORED_BUTTON;
export const COLORED_BUTTON_LABEL = `${COLORED_BUTTON_PREFIX}-label`;
export const COLORED_BUTTON_SPAN = `${COLORED_BUTTON_PREFIX}-span`;

//Plan selector
export const PLAN_SELECTOR = `${PREFIX}plan-selector`;
export const PLAN_SELECTOR_TITLE = `${PLAN_SELECTOR}-title`
export const PLAN_SELECTOR_ITEM = `${PREFIX}plan-selector-item`;
export const PLAN_SELECTOR_ITEM_CARD = `${PLAN_SELECTOR_ITEM}-card`;
export const PLAN_SELECTOR_ITEM_MORE_INFO = `${PLAN_SELECTOR_ITEM}-more-info`;
export const PLAN_SELECTOR_ITEM_MORE_INFO_TAB = `${PLAN_SELECTOR_ITEM_MORE_INFO}-tab`;
export const PLAN_SELECTOR_ITEM_MORE_INFO_TAB_ACTIVE = `${PLAN_SELECTOR_ITEM_MORE_INFO_TAB}-active`;
export const PLAN_SELECTOR_ITEM_MORE_INFO_TAB_DEACTIVATE = `${PLAN_SELECTOR_ITEM_MORE_INFO_TAB}-deactivate`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT = `${PLAN_SELECTOR_ITEM_CARD}-content`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD = `${PLAN_SELECTOR_ITEM_CARD}-period`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_IN_MODAL_ADD_ON = `${PLAN_SELECTOR_ITEM_CARD}-period-in-modal-add-on`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION1 = `${PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD}-promotion1`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION2 = `${PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD}-promotion2`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION3 = `${PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD}-promotion3`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD_PROMOTION_IN_MODAL_ADD_ON = `${PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD}-in-modal-add-on`;

export const PLAN_SELECTOR_ITEM_CARD_CONTENT_PROVIDER_LOGO = `${PLAN_SELECTOR_ITEM_CARD_CONTENT}-provider-logo`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION = `${PLAN_SELECTOR_ITEM_CARD_CONTENT}-description`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_CURRRENCY = `${PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION}-currency`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE = `${PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION}-price`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PERIODICITY = `${PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION}-periodicity`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_TAX = `${PLAN_SELECTOR_ITEM_CARD_CONTENT}-tax`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_SLASH = `${PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION}-slash`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE_FREQUENCY = `${PLAN_SELECTOR_ITEM_CARD_CONTENT}-price-frequency`;
export const PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE_TAXES = `${PLAN_SELECTOR_ITEM_CARD_CONTENT}-price-taxes`;


//Transaction Detail
export const DETAILTRANSACTION = `${PREFIX}transaction_detail`;
export const DETAILTRANSACTION_ROW = `${PREFIX}transaction_detail-row`;
export const DETAILTRANSACTION_ROW_BUTTON = `${PREFIX}transaction_detail-row-buttont`;
export const DETAILTRANSACTION_COLUMN = `${PREFIX}transaction_detail-column`;
export const DETAILTRANSACTION_COLUMN_TITLE = `${PREFIX}transaction_detail-column-title`;
export const DETAILTRANSACTION_COLUMN_CONTENT_IMAGE = `${PREFIX}transaction_detail-column-content-image`;
export const DETAILTRANSACTION_COLUMN_BUY_RENT = `${PREFIX}transaction_detail-column-buy-rent`;
export const DETAILTRANSACTION_COLUMN_EPISODE = `${PREFIX}transaction_detail-column-episode`;
export const DETAILTRANSACTION_COLUMN_SUSCRIPTION = `${PREFIX}transaction_detail-column-suscription`;
export const DETAILTRANSACTION_HEADER_LOGO = `${PREFIX}transaction_detail-header-logo`;
export const DETAILTRANSACTION_HEADER_BUTTON = `${PREFIX}transaction_detail-header-buttons`;
export const DETAILTRANSACTION_TITLE = `${PREFIX}transaction_detail-title`;
export const DETAILTRANSACTION_TITLE_EPISODE = `${PREFIX}transaction_detail-title-episode`;
export const DETAILTRANSACTION_COLUMN_TITLE_STEP =`${PREFIX}transaction_detail-title-step`;
export const DETAILTRANSACTION_SUBTITLE = `${PREFIX}transaction_detail-subtitle`;
export const DETAILTRANSACTION_SUBTITLE_TOTAL = `${PREFIX}transaction_detail-subtitle-total`;
export const DETAILTRANSACTION_SUBTITLE_PRICE = `${PREFIX}transaction_detail-subtitle-price`;
export const DETAILTRANSACTION_SUBTITLE_SLASH = `${PREFIX}transaction_detail-subtitle-slash`;
export const DETAILTRANSACTION_SUBTITLE_DURATION = `${PREFIX}transaction_detail-subtitle-duration`;
export const DETAILTRANSACTION_SUBTITLE_CARGO = `${PREFIX}transaction_detail-subtitle-cargo`;
export const DETAILTRANSACTION_SUBTITLE_INFORMATION = `${PREFIX}transaction_detail-subtitle-information`;
export const DETAILTRANSACTION_COLUMN_NOTES = `${PREFIX}transaction_detail-column-notes`;
export const DETAILTRANSACTION_COLUMN_DISCLAIMER = `${PREFIX}transaction_detail-disclaimer`;
export const DETAILTRANSACTION_COLUMN_EXTRA_DISCLAIMER = `${PREFIX}transaction_detail-extra-disclaimer`;
export const DETAILTRANSACTION_BUTTON_ACCEPT = `${PREFIX}transaction_detail-button-accept`;
export const DETAILTRANSACTION_NEW_BUTTON_ACCEPT = `${PREFIX}transaction_detail-new-button-accept`;
export const DETAILTRANSACTION_BUTTON_CANCEL = `${PREFIX}transaction_detail-button-cancel`;
export const DETAILTRANSACTION_NEW_BUTTON_CANCEL = `${PREFIX}transaction_detail-new-button-cancel`;
export const DETAILTRANSACTION_CONTENT = `${PREFIX}transaction_detail-content`;
export const DETAILTRANSACTION_COINTAINER_NOTES = `${PREFIX}transaction_detail-container-notes`;
export const DETAILTRANSACTION_CONTAINER_IMAGE = `${PREFIX}transaction_detail-container-image`
export const DETAILTRANSACTION_BUTTON_NEXT_FREEMIUM = `${PREFIX}transaction_detail-button-next-freemium`
export const DETAILTRANSACTION_COLUMN_RENTADESCRIPCIONCONTENT = `${PREFIX}transaction_detail-column-notes-rentaDescripcionContent`;


export const DETAILTRANSACTION_COLUMN_SUSCRIPTION_PUBLICITY = `${PREFIX}transaction_detail-column-suscription-publicity`;
export const DETAILTRANSACTION_COMPOUND_FORMS_INFORMATION = `${PREFIX}transaction_detail-compound_forms_information_publicity`;
export const DETAILTRANSACTION_COMPOUND_FORMS_INFORMATION_SUSCRIPTION = `${PREFIX}transaction_detail-compound_forms_information_publicity_suscription`;
export const DETAILTRANSACTION_SUBTITLE_CARGO_PUBLICITY = `${PREFIX}transaction_detail-subtitle-cargo-publicity`;
export const DETAILTRANSACTION_COLUMN_CONTENT_IMAGE_PUBLICITY = `${PREFIX}transaction_detail-column-content-image-publicity`;
export const DETAILTRANSACTION_SUBTITLE_TOTAL_PUBLICITY = `${PREFIX}transaction_detail-subtitle-total-publicity`;
export const DETAILTRANSACTION_SUBTITLE_INFORMATION_PUBLICITY = `${PREFIX}transaction_detail-subtitle-information-publicity`;

export const DETAILTRANSACTION_COLUMN_EPISODE_PUBLICITY = `${PREFIX}transaction_detail-column-episode-publicity`;
export const DETAILTRANSACTION_TITLE_EPISODE_PUBLICITY = `${PREFIX}transaction_detail-title-episode-publicity`;
export const DETAILTRANSACTION_SUBTITLE_PUBLICITY = `${PREFIX}transaction_detail-subtitle-publicity`;
export const DETAILTRANSACTION_COLUMN_EXTRA_DISCLAIMER_PUBLICITY = `${PREFIX}transaction_detail-extra-disclaimer-publicity`;
export const DETAILTRANSACTION_COLUMN_DISCLAIMER_PUBLICITY = `${PREFIX}transaction_detail-disclaimer-publicity`;
export const DETAILTRANSACTION_COLUMN_NOTES_PUBLICITY = `${PREFIX}transaction_detail-column-notes-publicity`;
export const DETAILTRANSACTION_COLUMN_NOTES_PUBLICITY_BUY_RENT = `${PREFIX}transaction_detail-column-notes-publicity-buy-rent`;

export const DETAILTRANSACTION_COLUMN_BUY_RENT_PUBLICITY = `${PREFIX}transaction_detail-column-buy-rent-publicity`;
export const DETAILTRANSACTION_SUBTITLE_PRICE_PUBLICITY = `${PREFIX}transaction_detail-subtitle-price-publicity`;
export const DETAILTRANSACTION_SUBTITLE_DURATION_PUBLICITY = `${PREFIX}transaction_detail-subtitle-duration-publicity`;



//Selector Button
export const SELECTOR_BUTTON = `${PREFIX}selector-button`;

//Menu
export const MENU = `${PREFIX}menu`;
export const MENU_FIRST_ROW = `${MENU}-first-row`;
export const MENU_BTN_SEARCH = `${MENU}-btn-search`;
export const MENU_BTN_AVATAR= `${MENU}-btn-avatar`;
export const MENU_LOGO = `${MENU}-logo`;
export const MENU_FIRST_LEVEL= `${MENU}-first-level`;
export const MENU_BUTTON = `${MENU}-button`;
export const MENU_CONTAINER = `${MENU}-container`;
export const MENU_CONTAINER_MAIN = `${MENU_CONTAINER}-main`;
export const MENU_CONTAINER_LEFT = `${MENU_CONTAINER}-left`;
export const MENU_CONTAINER_CENTER = `${MENU_CONTAINER}-center`;
export const MENU_CONTAINER_RiGHT = `${MENU_CONTAINER}-right`;


//Checkbox
export const CHECKBOX = `${PREFIX}checkbox`;
export const CHECKBOX_LABEL = `${CHECKBOX}-label`;
export const CHECKBOX_ELEMENT = `${CHECKBOX}-element`;

//* RIBBON PLAN SELECTOR

export const RIBBON_PLAN_SELECTOR_ITEM = `${PREFIX}ribbon-plan-selector-item`;
export const RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO = `${RIBBON_PLAN_SELECTOR_ITEM}-more-info`;
export const RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO_TAB = `${RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO}-tab`;
export const RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO_TAB_ACTIVE = `${RIBBON_PLAN_SELECTOR_ITEM_MORE_INFO_TAB}-active`;



// WEBPACK FOOTER //
// ./src/packages/components/lib/utils/classes.ts